import {css, html} from 'lit';
import {customElement, property} from 'lit/decorators';
import {
  moduleSpacingStyles,
  normalizeStyles,
  typographyStyles,
} from '@webs/components-library/theming';
import {GridColumn} from "@webs/components-library/grid-column";

@customElement('webs-card-usp')
export class CardUsp extends GridColumn {

  static styles = [
    normalizeStyles,
    moduleSpacingStyles,
    typographyStyles,
    ...GridColumn.styles,
    css`
    .m-card-usp {
      background-color: var(--color-white);
      border-radius: 5px;
      margin-bottom: 1.7rem;
      padding: 0.5rem;
    }

    .m-card-usp .icon {
      margin-bottom: 1rem;
    }

    .m-card-usp h5 {
      margin-bottom: 0.5rem;
    }

    .text_color-orange {
      color: var(--color-orange);
    }

    .m-card-usp p {
      margin: 0;
    }
    `
  ]

  @property()
  title: string;

  @property()
  description: string;

  @property({attribute: 'alternative-title'})
  alternativeTitle: boolean;

  @property({attribute: 'image-src'})
  imageSrc: string;

  protected render(): unknown {
    return html`
    <div class="m-card-usp">
      <div class="icon">
        <picture>
          <img src="${this.imageSrc}" alt="icon" height="50px" width="50px">
        </picture>
      </div>
      ${this.title? html`<h5 class="${this.alternativeTitle?"text_color-orange":""}">${this.title}</h5>`:""}
      ${this.description? html`
      <p>${this.description}</p>`:''}
    </div>
    `
  }
}
